import React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import ComputerIcon from "@material-ui/icons/Computer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SmsIcon from "@material-ui/icons/Sms";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import userStore from "../stores/userStore";
import { EventAvailable } from "@material-ui/icons";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import DnsIcon from "@material-ui/icons/Dns";

import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const drawerWidth = 240;

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: "flex"
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    drawerPaper: {
      width: drawerWidth
    },
    drawerContainer: {
      overflow: "auto"
    },
    content: {
      flexGrow: 1,
      paddingTop: 80,
      padding: theme.spacing(3)
    }
  })
);

export default function ClippedDrawer(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="title" content="인포테크 유지보수관리" />
        <meta
          name="description"
          content="인포테크 유지보수관리 웹사이트입니다."
        />
        <title>인포테크 통합 유지보수관리</title>

        <meta property="og:url" content="" />
        <meta
          property="og:description"
          content="인포테크 유지보수관리 웹사이트입니다."
        />
        <meta property="og:title" content="인포테크 유지보수관리" />
      </Helmet>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            인포테크 통합 유지보수관리
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            <ListItem button key="0" component={Link} to="/server">
              <ListItemIcon>
                <ComputerIcon />
              </ListItemIcon>
              <ListItemText primary="서버현황" />
            </ListItem>
            <ListItem button key="1" component={Link} to="/sms">
              <ListItemIcon>
                <SmsIcon />
              </ListItemIcon>
              <ListItemText primary="SMS" />
            </ListItem>
            <ListItem button key="2" component={Link} to="/location">
              <ListItemIcon>
                <LocationCityIcon />
              </ListItemIcon>
              <ListItemText primary="기관관리" />
            </ListItem>
            <ListItem button key="3" component={Link} to="/user">
              <ListItemIcon>
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="사용자관리" />
            </ListItem>
            <ListItem button key="4" component={Link} to="/logininfo">
              <ListItemIcon>
                <VpnKeyIcon />
              </ListItemIcon>
              <ListItemText primary="로그인정보" />
            </ListItem>
            <ListItem button key="5" component={Link} to="/expo">
              <ListItemIcon>
                <PhoneIphoneIcon />
              </ListItemIcon>
              <ListItemText primary="expo" />
            </ListItem>
            <ListItem button key="6" component={Link} to="/corona">
              <ListItemIcon>
                <EventAvailable />
              </ListItemIcon>
              <ListItemText primary="코로나19" />
            </ListItem>
            {/* <ListItem button key="6" component={Link} to="/copy">
              <ListItemIcon>
                <MenuBookIcon />
              </ListItemIcon>
              <ListItemText primary="복본체크" />
            </ListItem> */}
            <ListItem button key="7" component={Link} to="/ip">
              <ListItemIcon>
                <DnsIcon />
              </ListItemIcon>
              <ListItemText primary="사내IP 관리" />
            </ListItem>
            <ListItem button key="8" component={Link} to="/calculate">
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary="잡비 정산 내역" />
            </ListItem>

            <ListItem button key="9" component={Link} to="/attendance">
              <ListItemIcon>
                <EmojiTransportationIcon />
              </ListItemIcon>
              <ListItemText primary="출근부" />
            </ListItem>

            {/* {isDev && (
              <ListItem button key="10" component={Link} to="/copy2">
                <ListItemIcon>
                  <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary="복본체크2" />
              </ListItem>
            )} */}
            <ListItem button key="99" component={Link} to="/logout">
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="로그아웃" />
            </ListItem>
          </List>
        </div>
      </Drawer>
      <main className={classes.content}>{props.children}</main>
    </div>
  );
}
